import React from 'react';
import logoVertical from 'assets/img/logo-vertical.png';
import classNames from 'classnames';

interface LogoVerticalProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const LogoVertical = ({ width = 100, className }: LogoVerticalProps) => {
  return (
    <div
      className={classNames(className, 'icms-logo d-flex align-items-center')}
    >
      <img src={logoVertical} alt="phoenix" width={width} />
    </div>
  );
};

export default LogoVertical;
